<div class="container-fluid mt-3">
<!--      <prettyjson [obj]="specialDayForm.value"></prettyjson>-->
  <h2 class="text-center mb-3">{{ currentEditId ? 'Update Special Day':'Add Special Day' }}</h2>
  <form [formGroup]="specialDayForm" class="row" autocomplete="off">
    <!-- Session Date -->
    <div class="col-md-4 mb-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Select Date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="date" placeholder="Select date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>

    <app-searchable-select class="col-md-4"
                           [required]="true"
                           [options]="allTeachers"
                           [placeholder]="'Select Teacher Name'"
                           [label]="'Select Teacher Name'"
                           [selectedValue]="{ name: specialDayForm.get('teacherName')?.value }"
                           (selectionChange)="onTeacherSelected($event)"
    ></app-searchable-select>

    <app-searchable-select class="col-md-4"
                           [required]="true"
                           [options]="allCenters$ | async"
                           [selectedValue]="selectedCentre"
                           [displayWithFn]="displayCentre"
                           [placeholder]="'Select Centre'"
                           [label]="'Select Centre'"
                           (selectionChange)="onCentreSelect($event)"
    ></app-searchable-select>


<!--    <app-searchable-select class="col-md-4"-->
<!--                           [options]="_specialDay$ | async"-->
<!--                           [displayWithFn]="displaySpecialDay"-->
<!--                           [placeholder]="'Select Special Day'"-->
<!--                           [label]="'Select Special Day'"-->
<!--                           [isShowPlusIcon] = "true"-->
<!--                           (addButtonClicked)="handleAdd($event)"-->
<!--                           (selectionChange)="onSelectionSpecialDay($event)"-->
<!--    ></app-searchable-select>-->

    <app-searchable-select class="col-md-4"
                           [required]="true"
                           [options]="_specialDay$ | async"
                           [displayWithFn]="displaySpecialDay"
                           [placeholder]="'Select Special Day'"
                           [label]="'Select Special Day'"
                           [selectedValue]="selectedSpecialDay"
                           [isShowPlusIcon]="true"
                           (addButtonClicked)="handleAdd($event)"
                           (selectionChange)="onSelectionSpecialDay($event)"
    ></app-searchable-select>


    <mat-form-field appearance="outline" class="col-md-6">
      <mat-label>Select Files</mat-label>
      <ngx-mat-file-input
        placeholder="Select Files (Images/Documents)"
        (change)="onFileChange($event)"
        [disabled]="(data?.fileUrls?.length || 0) >= MAX_FILES"
        multiple
        accept=".pdf,.doc,.docx,.ppt,.pptx,.txt,image/*">
      </ngx-mat-file-input>
      <mat-icon matSuffix>folder</mat-icon>
      <mat-hint>Max 25MB per file. Images and documents only (no ZIP files)</mat-hint>
      <mat-error *ngIf="specialDayForm.get('fileUrls')?.hasError('invalidFile')">
        {{ specialDayForm.get('fileUrls')?.errors?.['message'] }}
      </mat-error>
      <div *ngIf="(data?.fileUrls?.length || 0) >= MAX_FILES" class="text-danger mt-1">
        Maximum {{ MAX_FILES }} files uploaded. You cannot add more files.
      </div>
    </mat-form-field>



    <!-- Add this section after the file input field -->
    <div class="col-12 mb-3" *ngIf="currentEditId && data?.fileUrls?.length">
      <mat-label>Existing Files:</mat-label>
      <mat-list>
        <mat-list-item *ngFor="let fileUrl of data.fileUrls; let i = index">
          <mat-icon matListIcon>insert_drive_file</mat-icon>
          <div matLine>
            <a [href]="fileUrl" target="_blank" rel="noopener noreferrer">
              {{ extractFileName(fileUrl) }}
            </a>
          </div>
          <button mat-icon-button color="warn" (click)="removeFile(i)" matTooltip="Remove file">
            <mat-icon>delete</mat-icon>
          </button>
        </mat-list-item>
      </mat-list>
    </div>


    <!-- Submit Button -->
    <div class="col-12 justify-content-center d-flex gap-2">
      <button mat-raised-button color="warn" (click)="onCancel()" >Cancel</button>
      <button mat-raised-button color="primary" [disabled]="specialDayForm.invalid || isLoading" (click)="submitForm()">{{ currentEditId ? 'Update ':'Submit' }}</button>
    </div>

  </form>
</div>

<!-- Loader Spinner (only visible while loading) -->
<div class="spinner-container" *ngIf="isLoading">
  <mat-spinner diameter="60"></mat-spinner>
</div>

